/* eslint-disable no-unused-vars */
import styled, { css } from 'styled-components';
import { Palette } from 'config';

export const Box = styled.div`
  padding: 0px 24px;
  max-height: 64px;
  display: flex;
  align-items: center;
  gap: 8px;
  max-width: 800px;
`;

export const DraggingContainer = styled.div`
  display: flex;
  flex-grow: 1;
  gap: 8px;
  height: 64px;
  align-items: center;
  /* border: 1px solid red; */
`;

export const ItemsContainer = styled.div`
  flex-grow: 1;
  overflow-y: auto;
  height: 400px;
  padding: 24px;
  background: ${Palette.PrimaryGray._000};
  ::-webkit-scrollbar {
    width: 6px;
    background-color: ${Palette.PrimaryGray._000};
  }

  ::-webkit-scrollbar-thumb {
    background-color: #cbd5e1;
    border-radius: 8px;
  }
`;
